import initFluveriaEngine from 'fluveria-engine-wasm';
import engineWasmUrl from 'fluveria-engine-wasm/fluveria_engine_wasm_bg.wasm?url';

let engineInitPromise: Promise<void> | null = null;

export function ensureFluveriaEngineInit(): Promise<void> {
  engineInitPromise ??= initFluveriaEngine({
    module_or_path: import.meta.env.DEV
      ? fetch(engineWasmUrl, { cache: 'no-store' })
      : engineWasmUrl,
  }).then(() => undefined);
  return engineInitPromise;
}
